import { NewIcon } from '@/components/icon'

export const IconNew: React.FC = () => {
  return (
    <NewIcon className="absolute top-[-16px] left-[-8px] z-50 w-[50px] h-[50px] text-fl-yellow bg-white rounded-full" />
  )
}
